import React, { useEffect, useState } from 'react';
import {
  Box, IconButton, Table, TableBody, TableCell,
  TableHead, TableRow, TextField, Typography
} from '@mui/material';
import { Add as AddIcon, Delete as DeleteIcon } from '@mui/icons-material';
import FormDialog from '../../common/FormDialog';

const EMPTY_ROW = () => ({ category_code: '', category_name: '', display_order: '', description: '' });

const BulkConductCategoryDialog = ({ open, onClose, onSubmit, saving, isMobile = false }) => {
  const [rows, setRows] = useState([EMPTY_ROW()]);

  useEffect(() => { if (open) setRows([EMPTY_ROW()]); }, [open]);

  const update = (i, field, value) =>
    setRows((prev) => prev.map((r, idx) => idx === i ? { ...r, [field]: value } : r));

  const handleSubmit = (e) => {
    e.preventDefault();
    const valid = rows.filter((r) => r.category_name.trim());
    if (!valid.length) return;
    onSubmit(valid, () => setRows([EMPTY_ROW()]));
  };

  const canSave = rows.some((r) => r.category_name.trim());

  return (
    <FormDialog
      open={open}
      onClose={onClose}
      onSubmit={handleSubmit}
      title="Bulk Add Conduct Categories"
      saving={saving}
      disabled={!canSave}
      isMobile={isMobile}
      maxWidth="lg"
    >
      <Box sx={{ overflowX: 'auto', pt: 1 }}>
        <Table size="small" sx={{ minWidth: 640 }}>
          <TableHead>
            <TableRow>
              <TableCell>Category Name *</TableCell>
              <TableCell>Code</TableCell>
              <TableCell>Display Order</TableCell>
              <TableCell>Description</TableCell>
              <TableCell />
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((row, i) => (
              <TableRow key={i}>
                <TableCell>
                  <TextField size="small" value={row.category_name}
                    onChange={(e) => update(i, 'category_name', e.target.value)}
                    placeholder="e.g. Attendance" sx={{ minWidth: 160 }} required />
                </TableCell>
                <TableCell>
                  <TextField size="small" value={row.category_code}
                    onChange={(e) => update(i, 'category_code', e.target.value.toUpperCase())}
                    placeholder="e.g. ATTEND" inputProps={{ maxLength: 20 }} sx={{ width: 110 }} />
                </TableCell>
                <TableCell>
                  <TextField size="small" type="number" value={row.display_order}
                    onChange={(e) => update(i, 'display_order', e.target.value)}
                    inputProps={{ min: 1 }} sx={{ width: 80 }} />
                </TableCell>
                <TableCell>
                  <TextField size="small" value={row.description}
                    onChange={(e) => update(i, 'description', e.target.value)}
                    placeholder="Optional description" sx={{ minWidth: 200 }} />
                </TableCell>
                <TableCell>
                  <IconButton size="small" color="error"
                    onClick={() => setRows((p) => p.filter((_, idx) => idx !== i))}
                    disabled={rows.length === 1}>
                    <DeleteIcon fontSize="small" />
                  </IconButton>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Box>

      <Box sx={{ mt: 1 }}>
        <IconButton size="small" color="primary" onClick={() => setRows((p) => [...p, EMPTY_ROW()])}>
          <AddIcon />
        </IconButton>
        <Typography variant="caption" color="text.secondary" sx={{ ml: 0.5 }}>Add row</Typography>
      </Box>
    </FormDialog>
  );
};

export default BulkConductCategoryDialog;
